import Hull from 'visuris/Data/Entities/Hull';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';

export default class HullRepository extends BaseRepository<Hull> {

    // See constructor
    private GETHULLS = "";
    private GETHULL = "";
    
    constructor() {
        super();
        this.GETHULLS = app.formatLocationUrl("~/visuris/api/hulls/gethulls");
        this.GETHULL = app.formatLocationUrl("~/visuris/api/hulls/gethull?flaRefId=");
    }

    public list(): Promise<Hull[]> {
        return new Promise<Hull[]>((resolve, reject) => {
            var $get = $.get(this.GETHULLS);
            $get.then((data) => {
                var hulls: Hull[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    hulls.push(HullRepository.fromDTO(item));
                }
                resolve(hulls);
            }, () => {
                reject();
            });
        });
    }
    public get(id: string): Promise<Hull> {
        return new Promise<Hull>((resolve, reject) => {
            var $get = $.get(this.GETHULL + id);
            $get.then((data) => {
                resolve(HullRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public static fromDTO(item: any): Hull {
        var hull = new Hull();
        hull.flaRefId = item.flaRefId;
        hull.name = item.name;
        hull.callSign = item.callSign;
        hull.mmsi = item.mmsi;
        hull.imo = item.imo;
        hull.eni = item.eni;
        hull.hin = item.hin;
        hull.atis = item.atis;
        hull.tonnageCertificateNumber = item.tonnageCertificateNumber;
        hull.matchID = item.matchID;
        hull.synchronizedOn = BaseRepository.anyToDate(item.synchronizedOn);
        hull.maritime = item.maritime;
        hull.bowThruster = item.bowThruster;
        hull.fixedPitchPropeller = item.fixedPitchPropeller;
        hull.doubleHull = item.doublehull;
        hull.width = item.width;
        hull.length = item.length;
        hull.grossRegisterTon = item.grossRegisterTon;
        hull.maximumSpeed = item.maximumSpeed;
        hull.maximumDraught = item.maximumDraught;
        hull.maximumHeight = item.maximumHeight;
        hull.deadweight = item.deadweight;
        hull.cellphone = item.cellphone;
        hull.email = item.email;
        hull.country = item.country;
        hull.hullType = item.hullType;
        hull.ownerName = item.ownerName;
        hull.ownerDateOfBirth = BaseRepository.anyToDate(item.ownerDateOfBirth);
        hull.ownerTelephone = item.ownerTelephone;
        hull.ownerCellphone = item.ownerCellphone;
        hull.ownerFax = item.ownerFax;
        hull.ownerEmail = item.ownerEmail;
        hull.ownerVAT = item.ownerVAT;
        hull.ownerBIC = item.ownerBIC;
        hull.ownerIBAN = item.ownerIBAN;
        hull.ownerPaymentMethod = item.ownerPaymentMethod;
        hull.tonnageCertificateIssueDate = BaseRepository.anyToDate(item.tonnageCertificateIssueDate);
        hull.tonnageCertificateValidFrom = BaseRepository.anyToDate(item.tonnageCertificateValidFrom);
        hull.tonnageCertificateValidTo = BaseRepository.anyToDate(item.tonnageCertificateValidTo);
        hull.hullTypeMessage = item.hullTypeMessage;
        hull.linkID = item.linkID;
        hull.privacyClass = item.privacyClass;
        hull.owned = item.owned;
        return hull;
    }
}

